import { useCallback } from 'react';
import { create } from 'zustand';
import {
  DummyFetchedMerch,
  DummyFetchedProducts,
  DummyMarchInCart,
  DummyProductsInCart,
  DummyTicketsData,
} from './dummies';
import { cartWithDummies } from 'utils/constants';

const store = cartWithDummies
  ? {
      fetchedProducts: DummyFetchedProducts,
      fetchedMerchandising: DummyFetchedMerch,
      productsInCart: DummyProductsInCart,
      merchInCart: DummyMarchInCart,
      ticketsData: DummyTicketsData,
    }
  : {
      fetchedProducts: undefined,
      fetchedMerchandising: undefined,
      productsInCart: [],
      merchInCart: [],
      ticketsData: [],
      submittedDiscountCodesWithEmptySpaces: [],
    };

const useStore = create(() => ({
  ...store,
  stepperCurrentTicketIdx: 0,
  loggedDataAtIndex: null,
  alertData: null,
  isEditingTicketMode: false,
  isAddingCatalogueMode: false,
  ticketToEditDates: null,
  isCartFull: false,
}));

const useTicketsSelector = () => useStore(useCallback((state) => state, []));
export { useTicketsSelector, useStore as useTicketsStore };
